import { render, staticRenderFns } from "./Edit2.vue?vue&type=template&id=238ae4ae"
import script from "./Edit2.vue?vue&type=script&lang=js"
export * from "./Edit2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports